<template>
  <div>
    <div class="form-group default-input">
      <textarea
        class="form-control with-label"
        @input="handleInput"
        :value="value"
        placeholder=""
      ></textarea>
      <label>{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultTextarea',
  props: [
    'label',
    'value'
  ],
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
